<template>
  <user-session-base-template>
    <keep-alive>
      <component
        :is="stepComponents[currentStep]"
        @channel-selected="goToConfirmationTokenStep($event)"
        @back-to-channel-selection="goToChannelSelectionStep()"
        @reset-password-token-generated="goToResetPasswordStep($event)"
        :reset-password-token="resetPasswordToken"
        :selected-channel="selectedChannel"
      />
    </keep-alive>
  </user-session-base-template>
</template>

<script>
import UserSessionBaseTemplate from 'components/user-session-base-template';
import RecoverPasswordChannel from 'pages/recover-password/components/recover-password-channel';
import ConfirmationToken from 'pages/recover-password/components/confirmation-token';
import ResetPassword from 'pages/recover-password/components/reset-password';

export default {
  components: {
    UserSessionBaseTemplate,
    RecoverPasswordChannel,
  },
  beforeMount() {
    if (this.$route.query.reset_password_token) {
      this.goToResetPasswordStep(this.$route.query.reset_password_token);
    }
  },
  data() {
    return {
      currentStep: 'channel-selection',
      stepComponents: {
        'channel-selection': RecoverPasswordChannel,
        'confirmation-token': ConfirmationToken,
        'reset-password': ResetPassword,
      },
      selectedChannel: {},
      resetPasswordToken: null,
    };
  },
  methods: {
    goToConfirmationTokenStep(channel) {
      this.selectedChannel = channel;

      this.currentStep = 'confirmation-token';
    },
    goToChannelSelectionStep() {
      this.currentStep = 'channel-selection';
    },
    goToResetPasswordStep(resetPasswordToken) {
      this.resetPasswordToken = resetPasswordToken;

      this.currentStep = 'reset-password';
    },
  },
};
</script>
